module.exports = __webpack_public_path__ + "img/icon-navbar-Creative-demo.dee801df.png";